<template>
  <label 
    class="tag" 
    @click.prevent="clickHandler" 
  >
    <span class=" ellipsis-1">{{ tag.name }}</span>
  </label>
  <!-- 
  <span :style="{ display : 'block' }"
    v-for="( tag , i ) in list"
  >{{ tag.name }}</span> 
  -->
</template>

<script>
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew";
import TagAddPopComm from "@TagAddPop/TagAddPopComm"; 
export default {
  mixins : [ TagAddPopComm ] , 
  props : {
    tag : Object , 
  } , 
  computed : {
    ...commNewMapGetters([
      'dragTag' , 
    ]) , 
  } , 
  methods : {
    ...commNewMapMutations([
      'dragTagUpdate' , 
    ]) , 
    clickHandler ( e ) {
      let { 
        tag , tag : {
          tagShape , 
          id : tagId , 
          name : label , 
          tagType : category , 
        } , 
        dragTag , 
        pos : { x , y } , 
        callbackFunc , 
      } = this ; 
      
      if ( callbackFunc == null ) {
        // this.dragTagUpdate( dragTag ) ; 
        Object.assign( dragTag , {
          ...dragTag , 
          dropBln : true , 
          pos : { x , y } , 
          data : {
            label , 
            tagId : String( tagId ) , 
            category , 
            tagShape , 
            hasProtocol : false , 
          } , 
        }) ; 
      } else {
        callbackFunc( tag ) ; // components/nav_process/Editor/index.vue => tagChangeHandler
        this.setCallbackFunc( null ) ; 
      }

      this.setTagOptionPopAddListViewBln({ bln : false }) ; 

    } , // end of clickHandler 
  } , 
}
</script>

<style lang="scss" scoped>
  label.tag {
    display: flex; 
    width: 100%; 
    height: 33px; 
    flex-shrink: 0; 
    align-items: center; 
    font-size: 14px; 
    border-radius: 4px; 
    cursor: pointer; 

    @include text-prt-m; 

    &:hover {
      background-color: $gray-e; 
    }
  }
</style>